(function () {
  var form = document.getElementById('ds-verify-form');
  var input = document.getElementById('ds-verify-input');
  var result = document.getElementById('ds-verify-result');
  var section = document.getElementById('ds-verify');
  var logo = document.getElementById('ds-verify-logo');
  var headingEl = document.getElementById('ds-verify-heading');
  var subheadingEl = document.getElementById('ds-verify-subheading');
  if (!form) return;

  var cfg = window.dsVerifyConfig;

  if (cfg.brandingEndpoint) {
    fetch(cfg.brandingEndpoint)
      .then(function (res) { return res.json(); })
      .then(function (branding) {
        if (branding.heading) headingEl.textContent = branding.heading;
        if (branding.subheading) subheadingEl.textContent = branding.subheading;
        if (branding.primary_color) section.style.setProperty('--ds-verify-accent', branding.primary_color);
        if (branding.logo_url) {
          logo.src = branding.logo_url;
          logo.hidden = false;
        }
      })
      .catch(function () { /* static Liquid defaults already rendered — fine to skip */ });
  }

  function render(state, data) {
    result.hidden = false;
    result.dataset.state = state;

    if (state === 'found') {
      var product = data.product;
      result.innerHTML =
        '<span class="ds-verify__badge">Verified Original</span>' +
        '<div class="ds-verify__result-product">' +
        (product.image ? '<img src="' + product.image + '" alt="">' : '') +
        '<div><strong>' + product.title + '</strong><br>' +
        'Purchased by ' + data.displayName +
        (product.url ? '<br><a class="ds-verify__product-link" href="' + product.url + '">View this product →</a>' : '') +
        '</div>' +
        '</div>';
    } else if (state === 'not-found') {
      result.innerHTML = 'We couldn’t find that serial number. Please check the label and try again.';
    } else {
      result.innerHTML = 'Something went wrong. Please try again in a moment.';
    }
  }

  function verify(code) {
    fetch(cfg.verifyEndpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ code: code })
    })
      .then(function (res) { return res.json(); })
      .then(function (json) {
        if (!json.matched) return render('not-found');
        render('found', { displayName: json.displayName, product: json.product });
      })
      .catch(function () { render('error'); });
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var code = input.value.trim();
    if (!code) return;
    verify(code);
  });

  // supports QR codes that link straight to a result, e.g. .../pages/verify?serial=ADS-XXXX
  var serialParam = new URLSearchParams(window.location.search).get('serial');
  if (serialParam) {
    input.value = serialParam;
    verify(serialParam.trim());
  }
})();
